<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Nos vidéos " />
            <ViDeo />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ViDeo from '../Video/ViDeo.vue'


export default {
    name: 'VideoPage',
    components: {
        NavBar,
        PageTitle,
        ViDeo,
        FooterComp,
    }
}
</script>